var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSurface = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.2647 1.83304H0.685388C0.326746 1.83304 0.0364583 1.42244 0.0364583 0.91652C0.0364583 0.410601 0.326746 0 0.685388 0H15.2647C15.6229 0 15.9136 0.410601 15.9136 0.91652C15.9136 1.42244 15.6229 1.83304 15.2647 1.83304Z",
  fill: "#1D1D1B"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5674 3.33333H0.43262C0.193814 3.33333 0 3.57218 0 3.86648V13.4669C0 13.7612 0.193814 14 0.43262 14H15.5674C15.8062 14 16 13.7612 16 13.4669V3.86648C16 3.57218 15.8062 3.33333 15.5674 3.33333ZM6.42007 12.9337L10.5927 4.39963H14.2003L10.0277 12.9337H6.42007ZM1.73394 12.9337L5.90655 4.39963H9.58252L5.40991 12.9337H1.73394ZM4.89596 4.39963L0.865239 12.6437V4.39963H4.89596ZM11.0379 12.9337L15.1348 4.55424V12.9337H11.0379Z",
  fill: "#CCCCCC"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSurface);
export { ForwardRef as ReactComponent };